import { useTokenStore } from '@/store/modules/token';
import { collectClientInfo } from './clientInfo';

const errorUrl: string = import.meta.env.VITE_ERROR_LOG_URL;
export const code: string = import.meta.env.VITE_ERROR_LOG_CODE;

const isLogReady = !!errorUrl && !!code;

function getPageInfo(): { pageUrl: string, pageQueryParams: string } {
  // #ifdef H5
  const [url, query] = window.location.href.split('?');
  return { pageUrl: url, pageQueryParams: query || '' };
  // #endif
  // #ifndef H5
  return { pageUrl: '', pageQueryParams: '' };
  // #endif
}

function getToken(): string {
  try {
    return useTokenStore().validToken || '';
  }
  catch {
    return '';
  }
}

function report(endpoint: string, data: Record<string, any>) {
  if (!isLogReady) return;
  uni.request({
    url: `${errorUrl}/api/${endpoint}/add`,
    method: 'POST',
    header: { 'Content-Type': 'application/json' },
    data,
    timeout: 10000,
    success: () => {},
    fail: () => {},
  });
}

export interface PostData {
  errorMessage: string
  lineNumber?: number
  columnNumber?: number
  errorType?: string
  errorStack?: string
  additionalData?: object
}

export function sendError(data: PostData) {
  if (!isLogReady) return;
  const { pageUrl, pageQueryParams } = getPageInfo();
  const { userAgent, deviceType, os, browser } = collectClientInfo();
  report('error', {
    ...data,
    code,
    token: getToken(),
    pageUrl,
    pageQueryParams,
    userAgent,
    deviceType,
    osVersion: os,
    browserVersion: browser,
    additionalData: {
      appType: import.meta.env.VITE_APP_TYPE,
      ...data.additionalData,
    },
  });
}

export interface EventData {
  eventType: string
  actionData: object
  additionalInfo?: object
}

export function sendEvent(data: EventData) {
  if (!isLogReady) return;
  const { pageUrl, pageQueryParams } = getPageInfo();
  const { deviceType, os, browser } = collectClientInfo();
  report('event', {
    ...data,
    code,
    pageUrl,
    pageQueryParams,
    token: getToken(),
    deviceType,
    os,
    browser,
  });
}

export interface VisitData {
  referrer?: string
  duration?: number
  pageUrl?: string
  pageQueryParams?: string
}

export function sendVisit(data: VisitData = {}) {
  if (!isLogReady) return;
  const { pageUrl: defaultUrl, pageQueryParams: defaultQuery } = getPageInfo();
  const { pageUrl = defaultUrl, pageQueryParams = defaultQuery, ...rest } = data;
  const { userAgent, deviceType, os, browser, screenResolution } = collectClientInfo();
  report('visit', {
    ...rest,
    code,
    pageUrl,
    pageQueryParams,
    token: getToken(),
    userAgent,
    deviceType,
    os,
    browser,
    screenResolution,
  });
}

export function sendVisitBeacon(data: VisitData = {}) {
  if (!isLogReady) return;
  // #ifdef H5
  const { pageUrl: defaultUrl, pageQueryParams: defaultQuery } = getPageInfo();
  const { pageUrl = defaultUrl, pageQueryParams = defaultQuery, ...rest } = data;
  const { userAgent, deviceType, os, browser, screenResolution } = collectClientInfo();
  navigator.sendBeacon(
    `${errorUrl}/api/visit/add`,
    new Blob(
      [
        JSON.stringify({
          ...rest,
          code,
          pageUrl,
          pageQueryParams,
          token: getToken(),
          userAgent,
          deviceType,
          os,
          browser,
          screenResolution,
        }),
      ],
      { type: 'application/json' },
    ),
  );
  // #endif
}
